import { Message, Load } from '@/components/Aomi-ui'
import router from '@/router'

import {
  API_LEVEL1_CODE,
  API_LEVEL1_CODE_MSG,
  API_LEVEL2_CODE,
  API_LEVEL2_CODE_MSG,
  API_RESULT,
  API_TIMEOUT_TIP,
  API_NETERROR_TIP,
  API_LOADING,
  API_GLOBAL_LOADING_ID,
  API_SUCCESS_CODE,
  API_USER_CODE,
  SUCCESS_CODE
} from '@/config'

export function requestSuccess (req) {
  if (API_LOADING && req.loading) {
    const loadingOpt = {
      fullscreen: false,
      target: document.querySelector(`#${API_GLOBAL_LOADING_ID}`)
    }
    if (typeof req.loading === 'object') {
      Load.open(Object.assign(loadingOpt, req.loading))
    } else {
      Load.open(loadingOpt)
    }
  }
  return req
}

export function requestFail (req) {
  Load.close()
  console.log('reqFail:', req)
}

export function responseSuccess(res) {
  Load.close()
  const apiData = res.data
  const level1Code = API_LEVEL1_CODE(apiData)
  const LoginCode = API_USER_CODE(apiData)
  const level1CodeMsg = API_LEVEL1_CODE_MSG(apiData)
  const level2Code = API_LEVEL2_CODE(apiData)
  const level2CodeMsg = API_LEVEL2_CODE_MSG(apiData)
  const apiResult = API_RESULT(apiData)
  const unHandleCode = res.config.unHandleCode
  if (Number(LoginCode) === 401 || Number(level1Code) === 401) {
    if (Number(level2Code) === 9003) {
      Message.error('無此資源使用權限，請聯繫管理員。')
      router.push({ path: '/dashboard' })
      return
    } else if (Number(level2Code) === 2008 || Number(level2Code) === 2007) {
      Message.error(`${level2Code}（${level2CodeMsg}）`)
      localStorage.clear()
      setTimeout(() => {
        location.reload()
      }, 2000)
    }
  }
  return new Promise((resolve, reject) => {
    if (Number(level1Code) === API_SUCCESS_CODE || Number(LoginCode) === SUCCESS_CODE) {
      resolve(apiResult)
    } else {
      if (unHandleCode) {
        if (unHandleCode[0] == level1Code) {
          resolve(apiData)
        }
      } else {
        Message.error(`${level2Code}（${level2CodeMsg}）`)
        // eslint-disable-next-line prefer-promise-reject-errors
        reject()
      }
    }
  })
}

export function responseFail (error) {
  console.log('responseFail:', error)
  Load.close()
  const stringError = String(error)
  if (stringError.match('timeout') || stringError.match('ERR_TIMED_OUT')) {
    Message.error(API_TIMEOUT_TIP)
  } else {
    Message.error(`${API_NETERROR_TIP}（${stringError}）`)
  }
  return new Promise((resolve, reject) => {})
}
